import React from "react";
import styles from "./NewsletterSubscribe.module.css"
import { Modal } from "react-bootstrap";
import { CloseButton } from "react-bootstrap";
import MailchimpSubscribe from "react-mailchimp-subscribe";

const URL = `${process.env.REACT_APP_MAILCHIMP_URL}?u=${process.env.REACT_APP_MAILCHIMP_USER}&amp;id=${process.env.REACT_APP_MAILCHIMP_ID}`

const CustomForm = ({ status, message, onValidated }) => {
    let email, fname, lname;
    const submit = () =>
      email &&
      fname &&
      lname &&
      email.value.indexOf("@") > -1 &&
      onValidated({
        MERGE0: email.value,
        MERGE1: fname.value,
        MERGE2: lname.value,
        "group[12677][1]": 1,
        "group[12677][2]": 1,
        "group[12677][4]": 1,
        "group[12677][8]": 1,
        "group[12677][16]": 1,
        "group[12677][32]": 1,
        "group[12677][64]": 1,
    });
  
    return (
        <>
            <div className={styles.messageWrapper}>
                {status === "sending" && <div className={styles.message}>sending...</div>}
                {status === "error" && (
                <div
                    className={styles.message}
                    style={{ color: "red" }}
                    dangerouslySetInnerHTML={{ __html: message }}
                />
                )}
                {status === "success" && (
                <div
                    className={styles.message}
                    style={{ color: "green" }}
                    dangerouslySetInnerHTML={{ __html: message }}
                />
                )}
            </div>
            <div
                className={styles.subscribeForm}
            >
                <input
                ref={node => (fname = node)}
                type="text"
                placeholder="First name"
                />
                <input
                ref={node => (lname = node)}
                type="text"
                placeholder="Last name"
                />
                <br />
                <input
                ref={node => (email = node)}
                type="email"
                placeholder="E-mail"
                />
                <br />
                <button className={styles.submitButton} onClick={submit}>
                Sign up
                </button>
            </div>
      </>
    );
  };
const NewsletterSubscribe = ({show, close}) => {
    const handleClose = React.useCallback(() => {
        close()
      }, [close])
    return (
        <Modal 
            show={show}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            dialogClassName={styles.NewsletterModal}
        >
            <Modal.Body className={styles.Newsletter}>
                <div
                className="close-button"
                role="button"
                tabIndex={0}
                onClick={() => handleClose()}
                >
                    <CloseButton />
                </div>
                    <div className={styles.NewsletterWrapper}>
                        <h2>Keep up to Date</h2>
                        <p>Be the first in the know. Sign up for articles and videos to keep the inspiration flowing, tips and tricks to take you to the top, and of course the latest D&AD News.</p>
                        <MailchimpSubscribe
                            url={URL}
                            render={({ subscribe, status, message }) => (
                                <CustomForm
                                    status={status}
                                    message={message}
                                    onValidated={formData => subscribe(formData)}
                            />
                            )}
                        />
                    </div>
            </Modal.Body>
        </Modal>
    )
}
export default NewsletterSubscribe